/*eslint-disable*/
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";

import ChatActions from "../../../actions/ChatActions";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";

class RerouteButtonFooter extends Component {
    constructor() {
        super();

        this.onRouteQuestion = this.onRouteQuestion.bind(this);
        this.onRouteQuestionKeyPress = this.onRouteQuestionKeyPress.bind(this);
    }

    onRouteQuestion(event) {
        ChatActions.reroute(this.props.question.uuid);
        event.preventDefault();

        if (this.props.onRerouteComplete) {
            this.props.onRerouteComplete();
        }
    }

    onRouteQuestionKeyPress(event) {
        if (event.charCode === 32 || event.charCode === 13) {
            this.onRouteQuestion(event);
        }
    }

    render() {
        const rerouteMessageClasses = classNames(
            "system-message",
            "message-reroute-question",
            "reroute-prompt",
            "btn-yellow "
        );

        return (
            <li>
                <button
                    className={rerouteMessageClasses}
                    onClick={this.onRouteQuestion}
                    onKeyPress={this.onRouteQuestionKeyPress}
                >
                    <strong>Opt out for this question</strong>
                </button>
            </li>
        );
    }
}

RerouteButtonFooter.propTypes = {
    question: PropTypes.objectOf(PropTypes.object).isRequired,

    onRerouteComplete: PropTypes.func,
};

export default RerouteButtonFooter;
